import { createContext } from 'react';

const QueryContext = createContext({
    catalog: [],
    onToggleChildren: () => {},
    onSubmit: () => {},
});

export default QueryContext;
